/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_Notes_Surround_SingleInputs */

const en_music_notes_surround_single = /** @type {(inputs: Music_Notes_Surround_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surround Single (♪... ♪)`)
};

const fr_music_notes_surround_single = /** @type {(inputs: Music_Notes_Surround_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encadrer simple (♪... ♪)`)
};

const de_music_notes_surround_single = /** @type {(inputs: Music_Notes_Surround_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surround Single (♪... ♪)`)
};

const it_music_notes_surround_single = /** @type {(inputs: Music_Notes_Surround_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surround Singolo (♪... ♪)`)
};

const ru_music_notes_surround_single = /** @type {(inputs: Music_Notes_Surround_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объемный звук (♪... ♪)`)
};

const es_music_notes_surround_single = /** @type {(inputs: Music_Notes_Surround_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonido envolvente sencillo (♪... ♪)`)
};

const zh_cn2_music_notes_surround_single = /** @type {(inputs: Music_Notes_Surround_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`环绕单曲（♪... ♪）`)
};

const ja_music_notes_surround_single = /** @type {(inputs: Music_Notes_Surround_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サラウンドシングル（♪…♪）`)
};

const hi_music_notes_surround_single = /** @type {(inputs: Music_Notes_Surround_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सराउंड सिंगल (♪... ♪)`)
};

const pt_pt2_music_notes_surround_single = /** @type {(inputs: Music_Notes_Surround_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surround Single (♪... ♪)`)
};

/**
* | output |
* | --- |
* | "Surround Single (♪... ♪)" |
*
* @param {Music_Notes_Surround_SingleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes_surround_single = /** @type {((inputs?: Music_Notes_Surround_SingleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_Notes_Surround_SingleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_music_notes_surround_single(inputs)
	if (locale === "de") return de_music_notes_surround_single(inputs)
	if (locale === "it") return it_music_notes_surround_single(inputs)
	if (locale === "ru") return ru_music_notes_surround_single(inputs)
	if (locale === "es") return es_music_notes_surround_single(inputs)
	if (locale === "zh-CN") return zh_cn2_music_notes_surround_single(inputs)
	if (locale === "ja") return ja_music_notes_surround_single(inputs)
	if (locale === "hi") return hi_music_notes_surround_single(inputs)
	if (locale === "pt-PT") return pt_pt2_music_notes_surround_single(inputs)
	return en_music_notes_surround_single(inputs)
});